/* eslint-disable */
import _ from 'underscore';
import Backbone from 'backbone';
import BaseProjection from '@bingads-webui-component-legacy/grid/projection/base';
import schema_properties from '@bingads-webui-component-legacy/grid/schema/properties';
import Response from '@bingads-webui-component-legacy/grid/model/response';
var Model = BaseProjection.extend({
  defaults: {
    'column.skip': 0,
    'column.take': Number.MAX_VALUE,
    'column.lock': [],
    'column.filter': function (i) {
      return true;
    },
    'column.in': undefined
  },
  name: 'column-queryable',
  update: function (options) {
    if (Model.__super__.update.call(this, options)) {
      var model = this.src.data, take = this.get('column.take'), skip = this.get('column.skip'), lock = this.get('column.lock') || [], filter = this.get('column.filter'), $in = this.get('column.in'), select = _.size(model.get('columns')) ? _.map(model.get('columns'), function (i) {
        return i.property;
      }) : model.get('select'), unlocked = _.isFunction(filter) ? _.filter($in || select, filter) : $in || select, lookup = {}, set = _.chain(unlocked).difference(lock).value(), col = set;
      _.each(model.get('columns'), function (element, index, list) {
        lookup[element.property] = element;
      });
      if (!_.isNumber(take)) {
        take = Number.MAX_VALUE;
      }
      take = Math.max(take - _.size(lock), 0);
      if (_.size(set) < skip) {
        skip = 0;
      }
      var skipped = _.first(set, skip);
      if (skip) {
        col = _.rest(set, skip);
      }
      var remaining = _.rest(col, take);
      col = _.union(lock, _.first(col, take));
      var res = _.map(col, function (element, index, list) {
        return _.defaults({
          $lock: _.contains(lock, element),
          property: element
        }, lookup[element]);
      });
      this.patch({
        'columns': res,
        'columns.skipped': skipped,
        'columns.remaining': remaining,
        'column.skip': skip
      });
    } else {}
  }
});
export default Model;

